import { newE2EPage } from "@stencil/core/testing";

describe("uic-accordion-item", () => {
    it("should set aria-expanded to false when closed", async () => {
        const page = await newE2EPage({
            html: `<uic-accordion-item></uic-accordion-item>`
        });

        const button = await page.find("button");
        const ariaExpanded = button.getAttribute("aria-expanded");
        expect(ariaExpanded).toEqual("false");
    });

    it("should set aria-expanded to true when open", async () => {
        const page = await newE2EPage({
            html: `<uic-accordion-item open></uic-accordion-item>`
        });

        const button = await page.find("button");
        const ariaExpanded = button.getAttribute("aria-expanded");
        expect(ariaExpanded).toEqual("true");
    });
});
